<template>
    <div class="chat-file-preview" :class="{ 'is-image': isImage }">
        <!-- Image Preview -->
        <template v-if="isImage">
            <img
                :src="attachment.url"
                :alt="attachment.fileName"
                class="image-preview"
                @click="openFullImage"
            />
        </template>

        <!-- File Preview -->
        <template v-else>
            <div class="file-info">
                <div class="file-icon">
                    <i class="material-icons">{{ fileIcon }}</i>
                </div>
                <div class="file-details">
                    <span class="file-name" :title="attachment.fileName">
                        {{ truncatedFileName }}
                    </span>
                    <span class="file-size">{{ formattedSize }}</span>
                </div>
                <a
                    :href="attachment.url"
                    target="_blank"
                    class="download-btn"
                    :download="attachment.fileName"
                >
                    <i class="material-icons">download</i>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ChatFilePreview',
    props: {
        attachment: {
            type: Object,
            required: true
        }
    },
    computed: {
        isImage() {
            const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp'];
            const ext = (this.attachment.fileType && this.attachment.fileType.toLowerCase()) || '';
            return imageTypes.includes(ext);
        },
        fileIcon() {
            const ext = (this.attachment.fileType && this.attachment.fileType.toLowerCase()) || '';
            const icons = {
                pdf: 'picture_as_pdf',
                doc: 'description',
                docx: 'description',
                xls: 'table_chart',
                xlsx: 'table_chart',
                txt: 'article',
                zip: 'folder_zip',
                rar: 'folder_zip'
            };
            return icons[ext] || 'insert_drive_file';
        },
        truncatedFileName() {
            const name = this.attachment.fileName || 'Fichier';
            if (name.length > 25) {
                const ext = name.split('.').pop();
                const base = name.substring(0, 20);
                return `${base}...${ext}`;
            }
            return name;
        },
        formattedSize() {
            const bytes = this.attachment.fileSize || 0;
            if (bytes === 0) return '';

            const k = 1024;
            const sizes = ['B', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));

            return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
        }
    },
    methods: {
        openFullImage() {
            window.open(this.attachment.url, '_blank');
        }
    }
};
</script>

<style scoped>
.chat-file-preview {
    max-width: 280px;
    border-radius: 8px;
    overflow: hidden;
}

.chat-file-preview.is-image {
    background: transparent;
}

.image-preview {
    max-width: 100%;
    max-height: 200px;
    border-radius: 8px;
    cursor: pointer;
    transition: opacity 0.2s;
}

.image-preview:hover {
    opacity: 0.9;
}

.file-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background-color: #f3f4f6;
    border-radius: 8px;
}

.file-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e5e7eb;
    border-radius: 8px;
    flex-shrink: 0;
}

.file-icon i {
    font-size: 20px;
    color: #6b7280;
}

.file-details {
    flex: 1;
    min-width: 0;
}

.file-name {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.file-size {
    font-size: 11px;
    color: #9ca3af;
}

.download-btn {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #059669;
    color: white;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.2s;
    flex-shrink: 0;
}

.download-btn:hover {
    background-color: #047857;
}

.download-btn i {
    font-size: 18px;
}
</style>
